<template>
    <div class="form-horizontal"
         enctype="multipart/form-data"
         @submit.prevent="store"
         @keydown="form.errors.clear($event.target.name)"
    >
        <table class="table table-striped">
            <tr>
                <th>{{ uLang('app.name') }}</th>
                <th>{{ uLang('app.action') }}</th>
            </tr>
            <tr v-for="applicationStatus in applicationStatuses">
                <td>
                    <input type="text"
                           v-if="applicationStatus.editable"
                           class="form-control"
                           :name="applicationStatus.value"
                           v-model="form['value'][applicationStatus.id]"
                    >
                    <span v-if="!applicationStatus.editable">{{ applicationStatus.value }}</span>
                </td>
                <td>
                    <a href="#" @click.prevent="removeApplicationStatus(applicationStatus)" class="btn btn-danger" v-if="applicationStatus.deleteable" :title="uLang('app.delete_document_type')">
                        <i class="fa fa-trash"></i>
                    </a>
                </td>
            </tr>
        </table>

        <div class="form-group">
            <div class="input-group">
                <input type="text"
                       class="form-control"
                       name="new"
                       v-model="newApplicationStatus"
                       placeholder="Type hier uw status"
                       title="Voeg nieuwe status voor sollicitatieactiviteiten toe"
                >
                <span class="input-group-btn">
                    <button type="button"
                            class="btn btn-success"
                            @click="addApplicationStatus"
                            :disabled="form.busy || ! newApplicationStatus"
                    >
                        {{ uLang('app.add_status', { type: lang('app.application_status') }) }}
                    </button>
                </span>
            </div>
        </div>

        <div class="form-group">
            <input :disabled="form.busy"
                   type="button"
                   :value="uLang('app.save_setting')"
                   @click="store()"
                   class="btn btn-brand"
            />
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'form-setting-application-status',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newApplicationStatus: '',
                applicationStatuses: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.status_successfully_updated', { type: lang('app.application_status') }) }).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.applicationStatuses = data;

                data.forEach(function (applicationStatus) {
                    if (applicationStatus.editable) {
                        this.value[applicationStatus.id] = applicationStatus.value;
                    }

                }, this.form);
            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addApplicationStatus() {
                if (this.newApplicationStatus === '')
                    return;

                this.applicationStatuses.push(
                    {
                        id: this.newApplicationStatus,
                        value: this.newApplicationStatus,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newApplicationStatus] = this.newApplicationStatus;
                this.newApplicationStatus = '';
            },

            removeApplicationStatus(ApplicationStatus) {
                new DestroyAlert({ entity: this.lang('app.application_status') }).show().then(async () => {
                    delete this.form.value[ApplicationStatus.id];

                    this.applicationStatuses = this.applicationStatuses.filter(function (currentApplicationStatus) {
                        return currentApplicationStatus.value != ApplicationStatus.value;
                    });
                });
            }
        }
    }
</script>

<style lang="css" scoped>

</style>
